<div class="container">
  <div class="card ticket-transfer-success-card">
    <div class="ticket-transfer-header">
      <h5 class="text-success fw-bold mb-0">{{ 'ticket.transfer.success.page.title' | translate }}</h5>
    </div>
    <div class="ticket-transfer-success-card-body">
      <p class="font-size-14 text-center" *ngSubscribe="transferedTickets$ as transferedTickets">
        {{ 'ticket.transfer.success.page.message' | translate : { emailAddress: transferedTickets[0].TransfereeEmailAddress } }}
      </p>

      <div class="ticket-transfer-success-table">
        <table class="table">
          <thead>
            <tr>
              <!-- @TODO -->
              <th scope="col">Ticket Number</th>
              <th scope="col">{{ 'ticket.transfer.success.page.table.area' | translate }}</th>
              <th scope="col">{{ 'ticket.transfer.success.page.table.section' | translate }}</th>
              <th scope="col">{{ 'ticket.transfer.success.page.table.row' | translate }}</th>
              <th scope="col">{{ 'ticket.transfer.success.page.table.seat' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of transferedTickets$ | async">
              <td scope="row">{{ item.ACN }}</td>
              <td>
                {{ item.Area }}
              </td>
              <td>{{ item.Stand }}</td>
              <td>{{ item.Row }}</td>
              <td>{{ item.Seat }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="action-wrapper">
      <button class="btn btn-primary fw-bold" type="button" (click)="goBack()">
        {{ 'ticket.transfer.success.page.back.button' | translate }}
      </button>
    </div>
  </div>
</div>
